import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.PlayerContactForm';

// Shared by every contact surface — the staff editor, the parent row editor and
// the add-a-co-parent dialog all label their fields from here.
export const getPlayerContactMessages = (termLookup: SportTermLookup) => {
  return defineMessages({
    lblName: {
      id: `${scope}.lblName`,
      defaultMessage: 'Full Name'
    },
    lblEmail: {
      id: `${scope}.lblEmail`,
      defaultMessage: 'Email'
    },
    lblPhone: {
      id: `${scope}.lblPhone`,
      defaultMessage: 'Phone'
    },
    lblSendEmail: {
      id: `${scope}.lblSendEmail`,
      defaultMessage: 'Send Email Communications'
    },
    lblSendSMS: {
      id: `${scope}.lblSendSMS`,
      defaultMessage: 'Send SMS Communications'
    },
    lblContactHeight: {
      id: `${scope}.lblContactHeight`,
      defaultMessage: 'Height (inches)'
    },
    lblContactSportInvolvement: {
      id: `${scope}.lblContactSportInvolvement`,
      defaultMessage: 'Involvement in Sport'
    },
    lblContactRelationship: {
      id: `${scope}.lblContactRelationship`,
      defaultMessage: 'Relationship to ' + termLookup[SportTerminology.ATHLETE]
    },
    btnSubmit: {
      id: `${scope}.btnSubmit`,
      defaultMessage: `Save`,
    },
    btnSubmitting: {
      id: `${scope}.btnSubmitting`,
      defaultMessage: 'Saving...',
    }
  });
}

// Duplicate-redundancy warnings, shown on every contact form — a credential the
// form blocks surfaces as a field error instead, never through this banner.
export const getContactDuplicateMessages = (termLookup: SportTermLookup) => {
  const athlete = termLookup[SportTerminology.ATHLETE].toLowerCase();

  return defineMessages({
    duplicateHeading: {
      id: `${scope}.duplicateHeading`,
      defaultMessage: 'This may already be covered'
    },
    duplicateEmail: {
      id: `${scope}.duplicateEmail`,
      defaultMessage: 'That email is already used by {contactName}.'
    },
    duplicatePhone: {
      id: `${scope}.duplicatePhone`,
      defaultMessage: 'That phone number is already used by {contactName}.'
    },
    duplicateName: {
      id: `${scope}.duplicateName`,
      defaultMessage: `A contact named {contactName} already exists for this ${athlete}.`
    },
    duplicateUnnamedContact: {
      id: `${scope}.duplicateUnnamedContact`,
      defaultMessage: 'another contact'
    },
    duplicateFooter: {
      id: `${scope}.duplicateFooter`,
      defaultMessage: 'You can still save this contact — it just may not be necessary.'
    }
  });
};

// Copy for the read-only contact roster rendered by ContactSummaryList.
export const contactSummaryMessages = defineMessages({
  contactUnnamed: {
    id: `${scope}.contactUnnamed`,
    defaultMessage: 'Contact'
  }
});

// Copy for the read-only roster of everyone else on an athlete.
export const otherContactsMessages = defineMessages({
  otherContactsShow: {
    id: `${scope}.otherContactsShow`,
    defaultMessage: 'Show other contacts ({count})'
  },
  otherContactsHide: {
    id: `${scope}.otherContactsHide`,
    defaultMessage: 'Hide other contacts'
  }
});
